var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbuntu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata1044"
  }, "image/svg+xml")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "g1021"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e95420",
    className: "st1",
    d: "m66.9,33.5c0,18.5 -15,33.5 -33.5,33.5c-18.5,0 -33.4,-15.1 -33.4,-33.5c0,-18.5 15,-33.5 33.5,-33.5c18.4,0 33.4,15 33.4,33.5z",
    id: "path1017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "st0",
    d: "m16.1,33.5c0,2.4 -1.9,4.3 -4.3,4.3c-2.4,0 -4.3,-1.9 -4.3,-4.3c0,-2.4 1.9,-4.3 4.3,-4.3c2.4,0 4.3,1.9 4.3,4.3zm24.5,20.9c1.2,2.1 3.8,2.8 5.9,1.6c2.1,-1.2 2.8,-3.8 1.6,-5.9c-1.2,-2.1 -3.8,-2.8 -5.9,-1.6c-2.1,1.2 -2.8,3.8 -1.6,5.9zm7.4,-37.6c1.2,-2.1 0.5,-4.7 -1.6,-5.9c-2.1,-1.2 -4.7,-0.5 -5.9,1.6c-1.2,2.1 -0.5,4.7 1.6,5.9c2.1,1.2 4.7,0.5 5.9,-1.6zm-14.5,4.4c6.4,0 11.7,4.9 12.2,11.2l6.2,-0.1c-0.3,-4.7 -2.3,-8.8 -5.4,-11.9c-1.6,0.6 -3.6,0.5 -5.2,-0.4c-1.7,-1 -2.7,-2.6 -3,-4.3c-1.5,-0.4 -3.2,-0.6 -4.9,-0.6c-2.9,0 -5.7,0.7 -8.2,1.9l3,5.4c1.7,-0.8 3.4,-1.2 5.3,-1.2zm-12.3,12.3c0,-4.1 2.1,-7.8 5.2,-10l-3.2,-5.3c-3.7,2.5 -6.5,6.2 -7.6,10.7c1.4,1.1 2.3,2.8 2.3,4.7c0,1.9 -0.9,3.6 -2.3,4.7c1.2,4.4 3.9,8.2 7.6,10.7l3.2,-5.3c-3.1,-2.4 -5.2,-6.1 -5.2,-10.2zm12.3,12.2c-1.8,0 -3.6,-0.4 -5.2,-1.1l-3,5.4c2.5,1.2 5.3,1.9 8.2,1.9c1.7,0 3.3,-0.2 4.9,-0.6c0.3,-1.7 1.3,-3.4 3,-4.3c1.6,-1 3.6,-1 5.2,-0.4c3.1,-3.1 5.1,-7.3 5.4,-11.9l-6.2,-0.1c-0.7,6.2 -5.9,11.1 -12.3,11.1z",
    id: "path1019"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.2ccc303131d47348ba4cc024efc1a193.svg";
export { ForwardRef as ReactComponent };